import { publicResourceProvider } from "../../constants/actionTypes";

const INITIAL_STATE = {
    cloud_vm: {
        data: [],
        loading: false
    },
    cloudVMOperation: {
        data: {},
        loading: false,
        success: false,
        error: false,
    },
    cloudProviderAzureList: {
        data: [],
        loading: false
    },
    // Cascading dropdowns
    resourceGroups: {
        data: [],
        loading: false,
    },
    computeGallery: {
        data: [],
        loading: false,
    },
    galleryImage: {
        data: [],
        loading: false,
    },
    instanceSize: {
        data: [],
        loading: false,
    },
    // Azure VM Template CRUD
    azureVmTemplate: {
        loading: false,
        success: false,
        error: false,
        data: null,
    },
    azureVmTemplateDetail: {
        loading: false,
        error: false,
        data: null,
    },
    azureVmTemplateList: {
        loading: false,
        error: false,
        data: null,
    },
    azureVmTemplateMutation: {
        loading: false,
        success: false,
        error: false,
    },
    // SKU Management
    azureSkus: {
        loading: false,
        error: false,
        data: [],
    },
    azureSkuMutation: {
        loading: false,
        success: false,
        error: false,
    },
}

const publicResourceManager = (state = INITIAL_STATE, action = {}) => {
    switch (action.type) {
        case publicResourceProvider.GET_CLOUD_VM_LIST_ACTION:
            return {
                ...state,
                cloud_vm: {
                    ...state?.cloud_vm,
                    loading: true,
                },
            };
        case publicResourceProvider.GET_CLOUD_VM_LIST_SUCCESS:
            return {
                ...state,
                cloud_vm: {
                    ...state?.cloud_vm,
                    loading: false,
                    data: action?.payload || [],
                },
            };
        case publicResourceProvider.GET_CLOUD_VM_LIST_ERROR:
            return {
                ...state,
                cloud_vm: {
                    ...state?.cloud_vm,
                    loading: false,
                },
            };
        case publicResourceProvider.GET_CLOUD_VM_LIST_RESET:
            return {
                ...state,
                cloud_vm: {
                    ...state?.cloud_vm,
                    loading: false,
                },
            };

        case publicResourceProvider.CLOUD_VM_OPERATION_ACTION:
            return {
                ...state,
                cloudVMOperation: {
                    ...state?.cloudVMOperation,
                    loading: true,
                    success: false,
                    error: false
                },
            };
        case publicResourceProvider.CLOUD_VM_OPERATION_SUCCESS:
            return {
                ...state,
                cloudVMOperation: {
                    ...state?.cloudVMOperation,
                    data: action?.payload || {},
                    loading: false,
                    success: true,
                    error: false
                },
            };
        case publicResourceProvider.CLOUD_VM_OPERATION_ERROR:
            return {
                ...state,
                cloudVMOperation: {
                    ...state?.cloudVMOperation,
                    data: {},
                    loading: false,
                    success: false,
                    error: true
                },
            };
        case publicResourceProvider.CLOUD_VM_OPERATION_RESET:
            return {
                ...state,
                cloudVMOperation: INITIAL_STATE.cloudVMOperation,
            };

        case publicResourceProvider.CLOUD_PROVIDER_AZURE_LIST_ACTION:
            return {
                ...state,
                cloudProviderAzureList: {
                    ...state?.cloudProviderAzureList,
                    loading: true,
                },
            };
        case publicResourceProvider.CLOUD_PROVIDER_AZURE_LIST_SUCCESS:
            return {
                ...state,
                cloudProviderAzureList: {
                    ...state?.cloudProviderAzureList,
                    loading: false,
                    data: action?.payload || [],
                },
            };
        case publicResourceProvider.CLOUD_PROVIDER_AZURE_LIST_ERROR:
            return {
                ...state,
                cloudProviderAzureList: {
                    ...state?.cloudProviderAzureList,
                    loading: false,
                },
            };
        case publicResourceProvider.CLOUD_PROVIDER_AZURE_LIST_RESET:
            return {
                ...state,
                cloudProviderAzureList: {
                    ...state?.cloudProviderAzureList,
                    loading: false,
                },
            };

        // ── Cascading Dropdowns ──────────────────────────────────────────────

        // Resource Groups
        case publicResourceProvider.FETCH_RESOURCE_GROUPS_ACTION:
            return { ...state, resourceGroups: { data: [], loading: true } };
        case publicResourceProvider.FETCH_RESOURCE_GROUPS_SUCCESS:
            return { ...state, resourceGroups: { data: Array.isArray(action?.payload) ? action.payload : [], loading: false } };
        case publicResourceProvider.FETCH_RESOURCE_GROUPS_ERROR:
            return { ...state, resourceGroups: { ...state.resourceGroups, loading: false } };
        case publicResourceProvider.FETCH_RESOURCE_GROUPS_RESET:
            return { ...state, resourceGroups: INITIAL_STATE.resourceGroups };

        // Compute Gallery — also clear downstream when this refreshes
        case publicResourceProvider.FETCH_COMPUTE_GALLERY_ACTION:
            return {
                ...state,
                computeGallery: { data: [], loading: true },
                galleryImage: INITIAL_STATE.galleryImage,
            };
        case publicResourceProvider.FETCH_COMPUTE_GALLERY_SUCCESS:
            return { ...state, computeGallery: { data: Array.isArray(action?.payload) ? action.payload : [], loading: false } };
        case publicResourceProvider.FETCH_COMPUTE_GALLERY_ERROR:
            return { ...state, computeGallery: { ...state.computeGallery, loading: false } };
        case publicResourceProvider.FETCH_COMPUTE_GALLERY_RESET:
            return { ...state, computeGallery: INITIAL_STATE.computeGallery };

        // Gallery Image — also clear downstream when this refreshes
        case publicResourceProvider.FETCH_GALLERY_IMAGE_ACTION:
            return {
                ...state,
                galleryImage: { data: [], loading: true },
            };
        case publicResourceProvider.FETCH_GALLERY_IMAGE_SUCCESS:
            return { ...state, galleryImage: { data: Array.isArray(action?.payload) ? action.payload : [], loading: false } };
        case publicResourceProvider.FETCH_GALLERY_IMAGE_ERROR:
            return { ...state, galleryImage: { ...state.galleryImage, loading: false } };
        case publicResourceProvider.FETCH_GALLERY_IMAGE_RESET:
            return { ...state, galleryImage: INITIAL_STATE.galleryImage };


        // Instance Size
        case publicResourceProvider.FETCH_INSTANCE_SIZE_ACTION:
            return { ...state, instanceSize: { data: [], loading: true } };
        case publicResourceProvider.FETCH_INSTANCE_SIZE_SUCCESS:
            return { ...state, instanceSize: { data: Array.isArray(action?.payload) ? action.payload : [], loading: false } };
        case publicResourceProvider.FETCH_INSTANCE_SIZE_ERROR:
            return { ...state, instanceSize: { ...state.instanceSize, loading: false } };
        case publicResourceProvider.FETCH_INSTANCE_SIZE_RESET:
            return { ...state, instanceSize: INITIAL_STATE.instanceSize };

        // ── Azure VM Template CRUD ───────────────────────────────────────────
        case publicResourceProvider.CREATE_AZURE_VM_TEMPLATE_ACTION:
        case publicResourceProvider.UPDATE_AZURE_VM_TEMPLATE_ACTION:
            return { ...state, azureVmTemplate: { ...state.azureVmTemplate, loading: true, success: false, error: false } };

        case publicResourceProvider.CREATE_AZURE_VM_TEMPLATE_SUCCESS:
        case publicResourceProvider.UPDATE_AZURE_VM_TEMPLATE_SUCCESS:
            return { ...state, azureVmTemplate: { data: action?.payload, loading: false, success: true, error: false } };

        case publicResourceProvider.CREATE_AZURE_VM_TEMPLATE_ERROR:
        case publicResourceProvider.UPDATE_AZURE_VM_TEMPLATE_ERROR:
            return { ...state, azureVmTemplate: { ...state.azureVmTemplate, loading: false, success: false, error: true } };

        case publicResourceProvider.CREATE_AZURE_VM_TEMPLATE_RESET:
        case publicResourceProvider.UPDATE_AZURE_VM_TEMPLATE_RESET:
            return { ...state, azureVmTemplate: INITIAL_STATE.azureVmTemplate };

        // ── Azure VM Template Retrieve ────────────────────────────────────────
        case publicResourceProvider.FETCH_AZURE_VM_TEMPLATE_ACTION:
            return { ...state, azureVmTemplateDetail: { data: null, loading: true, error: false } };
        case publicResourceProvider.FETCH_AZURE_VM_TEMPLATE_SUCCESS:
            return { ...state, azureVmTemplateDetail: { data: action?.payload, loading: false, error: false } };
        case publicResourceProvider.FETCH_AZURE_VM_TEMPLATE_ERROR:
            return { ...state, azureVmTemplateDetail: { ...state.azureVmTemplateDetail, loading: false, error: true } };
        case publicResourceProvider.FETCH_AZURE_VM_TEMPLATE_RESET:
            return { ...state, azureVmTemplateDetail: INITIAL_STATE.azureVmTemplateDetail };

        // ── Azure VM Template List ────────────────────────────────────────────
        case publicResourceProvider.LIST_AZURE_VM_TEMPLATES_ACTION:
            return { ...state, azureVmTemplateList: { data: null, loading: true, error: false } };
        case publicResourceProvider.LIST_AZURE_VM_TEMPLATES_SUCCESS:
            return { ...state, azureVmTemplateList: { data: action?.payload, loading: false, error: false } };
        case publicResourceProvider.LIST_AZURE_VM_TEMPLATES_ERROR:
            return { ...state, azureVmTemplateList: { ...state.azureVmTemplateList, loading: false, error: true } };
        case publicResourceProvider.LIST_AZURE_VM_TEMPLATES_RESET:
            return { ...state, azureVmTemplateList: INITIAL_STATE.azureVmTemplateList };

        // ── Azure VM Template Delete / Publish ────────────────────────────────
        case publicResourceProvider.DELETE_AZURE_VM_TEMPLATE_ACTION:
        case publicResourceProvider.PUBLISH_AZURE_VM_TEMPLATE_ACTION:
            return { ...state, azureVmTemplateMutation: { loading: true, success: false, error: false } };
        case publicResourceProvider.DELETE_AZURE_VM_TEMPLATE_SUCCESS:
        case publicResourceProvider.PUBLISH_AZURE_VM_TEMPLATE_SUCCESS:
            return { ...state, azureVmTemplateMutation: { loading: false, success: true, error: false } };
        case publicResourceProvider.DELETE_AZURE_VM_TEMPLATE_ERROR:
        case publicResourceProvider.PUBLISH_AZURE_VM_TEMPLATE_ERROR:
            return { ...state, azureVmTemplateMutation: { loading: false, success: false, error: true } };
        case publicResourceProvider.DELETE_AZURE_VM_TEMPLATE_RESET:
        case publicResourceProvider.PUBLISH_AZURE_VM_TEMPLATE_RESET:
            return { ...state, azureVmTemplateMutation: INITIAL_STATE.azureVmTemplateMutation };

        // ── SKU Management ────────────────────────────────────────────────────
        case publicResourceProvider.LIST_AZURE_SKUS_ACTION:
            return { ...state, azureSkus: { data: [], loading: true, error: false } };
        case publicResourceProvider.LIST_AZURE_SKUS_SUCCESS:
            return { ...state, azureSkus: { data: action?.payload || [], loading: false, error: false } };
        case publicResourceProvider.LIST_AZURE_SKUS_ERROR:
            return { ...state, azureSkus: { ...state.azureSkus, loading: false, error: true } };
        case publicResourceProvider.LIST_AZURE_SKUS_RESET:
            return { ...state, azureSkus: INITIAL_STATE.azureSkus };

        case publicResourceProvider.CREATE_AZURE_SKU_ACTION:
        case publicResourceProvider.UPDATE_AZURE_SKU_ACTION:
            return { ...state, azureSkuMutation: { loading: true, success: false, error: false } };
        case publicResourceProvider.CREATE_AZURE_SKU_SUCCESS:
        case publicResourceProvider.UPDATE_AZURE_SKU_SUCCESS:
            return { ...state, azureSkuMutation: { loading: false, success: true, error: false } };
        case publicResourceProvider.CREATE_AZURE_SKU_ERROR:
        case publicResourceProvider.UPDATE_AZURE_SKU_ERROR:
            return { ...state, azureSkuMutation: { loading: false, success: false, error: true } };
        case publicResourceProvider.CREATE_AZURE_SKU_RESET:
        case publicResourceProvider.UPDATE_AZURE_SKU_RESET:
            return { ...state, azureSkuMutation: INITIAL_STATE.azureSkuMutation };

        default:
            return state;
    }
}

export default publicResourceManager;
